import React, { useState } from 'react';
import { User, Settings, LogOut, HelpCircle } from 'lucide-react';
import { useAuth } from '../../store/AuthContext';
import NotificationCenter from '../notifications/NotificationCenter';
import Profile from './Profile';
import SettingsModal from './Settings';
import HelpSupport from './HelpSupport';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  return (
    <div className="flex items-center space-x-4">
      <NotificationCenter />
      
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100"
        >
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
            <span className="text-sm font-medium text-blue-800">
              {user?.username[0].toUpperCase()}
            </span>
          </div>
          <span className="text-sm text-gray-700">{user?.username}</span>
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="py-1">
              <div className="px-4 py-2 border-b border-gray-200">
                <p className="text-sm font-medium text-gray-900">{user?.username}</p>
                <p className="text-xs text-gray-500">Administrator</p>
              </div>

              <button
                onClick={() => {
                  setShowProfile(true);
                  setIsOpen(false);
                }}
                className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
              >
                <User className="w-4 h-4 mr-3" />
                Profile
              </button>

              <button
                onClick={() => {
                  setShowSettings(true);
                  setIsOpen(false);
                }}
                className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
              >
                <Settings className="w-4 h-4 mr-3" />
                Settings
              </button>

              <button
                onClick={() => {
                  setShowHelp(true);
                  setIsOpen(false);
                }}
                className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
              >
                <HelpCircle className="w-4 h-4 mr-3" />
                Help & Support
              </button>

              <div className="border-t border-gray-200">
                <button
                  onClick={handleLogout}
                  className="w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center"
                >
                  <LogOut className="w-4 h-4 mr-3" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {showProfile && <Profile onClose={() => setShowProfile(false)} />}
      {showSettings && <SettingsModal onClose={() => setShowSettings(false)} />}
      {showHelp && <HelpSupport onClose={() => setShowHelp(false)} />}
    </div>
  );
}